import { SelectedRowKeys } from '@common/types/components/table/table';
import { isNumber } from 'lodash';

export const getSelectedRowsWithoutGroupIDs = (selectedRows: SelectedRowKeys) => {
  return selectedRows.filter(isNumber);
};
